import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import EventOccasionsPage from "./event-occasions-page";
import EventOccasionCreatePage from "./event-occasion-create-page";
import EventOccasionEditPage from "./event-occasion-edit-page";
 

export default (
  <Route path="event-occasions">
    <Route
      index
      element={
        <Protected
          path="/admin/event-occasions"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <EventOccasionsPage />
        </Protected>
      }
    />

    <Route
      path="create"
      element={
        <Protected
          path="/admin/event-occasions/create"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <EventOccasionCreatePage />
        </Protected>
      }
    />
    
    <Route
      path="edit/:id"
      element={
        <Protected
          path="/admin/event-occasions/edit/:id"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <EventOccasionEditPage />
        </Protected>
      }
    />  
  </Route>
);



